"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var breakpoints = {
  desk: "min-width: 1024px",
  deskWide: "min-width: 1360px",
  desktop: "max-width: 1359px",
  jumbo: "min-width: 1600px",
  landscape: "orientation: landscape",
  lap: "min-width: 668px",
  mobile: "max-width: 479px",
  palm: "max-width: 667px",
  phablet: "min-width: 480px",
  portable: "max-width: 1023px",
  portrait: "orientation: portrait",
  "short": "max-height: 650px",
  tall: "min-height: 650px"
};

var makeMediaQuery = function makeMediaQuery(query) {
  return function () {
    return (0, _styledComponents.css)(["@media (", "){", ";}"], query, _styledComponents.css.apply(void 0, arguments));
  };
};

var queries = function queries(targets) {
  return makeMediaQuery(targets.map(function (target) {
    return breakpoints[target];
  }).join(") and ("));
};

var _default = Object.assign({}, Object.keys(breakpoints).reduce(function (accum, breakpoint) {
  var _Object$assign;

  return Object.assign({}, accum, (_Object$assign = {}, _Object$assign[breakpoint] = makeMediaQuery(breakpoints[breakpoint]), _Object$assign));
}, {}), {
  queries: queries
});

exports["default"] = _default;